import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import AddIcon from "@material-ui/icons/AddBox";
import uuid from "react-uuid";
import TextField from "@material-ui/core/TextField";
import refresh_token from "./../../Global/refresh_token";
import GlobalApi from "./../../Global/index";
import { Redirect } from "react-router";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import RootRef from "@material-ui/core/RootRef";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import DragIndicatorRoundedIcon from "@material-ui/icons/DragIndicatorRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  list: {
    //width: 250,
    width: "100%",
  },
  fullList: {
    width: "auto",
  },
  textBoxStyle: {
    //marginLeft:-theme.spacing.unit*8,
    paddingLeft: theme.spacing.unit,
    width: 350,
    marginBottom: 10,
    marginTop: 10,
    height: 40,
  },
  show: {
    //marginTop:15,
    padding: 10,
    backgroundColor: "#FFFFFF",
    width: "100%",
  },
  divStyle: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    borderRadius: 10,
  },
}));

const ResponseList = (props) => {
  let company = useSelector((state) => state.companyReducer.company);
  const classes = useStyles();
  const [responseSet, setResponseSet] = useState([
    { id: uuid(), title: "Response 1", position: "1",weight:0 },
  ]);
  const [refresh, setRefresh] = useState(false);
  const addResponse = () => {
    setRefresh(true);
  };
  React.useEffect(() => {
    if (refresh) {
      var count = responseSet.length + 1;
      var newResponse = {
        id: uuid(),
        title: "Response " + count.toString(),
        position: count,
        status: "new",
      };
      responseSet.push(newResponse);
      setResponseSet(responseSet);
      setRefresh(false);
    }
  });

  React.useEffect(() => {
    setResponseSet([{ id: uuid(), title: "Response 1", position: "1",weight:0 }]);
  }, []);
  const closeDrawer = () => {
    props.closeDrawer(false);
  };
  const closeWithSaveDrawer = async () => {
    var retrievedData = await localStorage.getItem("UserData");
    var data = await JSON.parse(retrievedData);
    if (data == null) {
      return <Redirect to={"/signin"} />;
    }
    var token = data.token;
    var user = data.user_id;
    var organization = data.organization_id;
    if (props.action == "New") {
      await addResponseSet(token, organization, user);
    } else {
      await responseSet.map(async (item, index) => {
        if (item.status == "added" || item.status == "deleted")
          await updateResponseDetail(
            token,
            item.id,
            item.title,
            index,
            item.status,
            item.weight,
          );

        if (item.status == "new")
          await addResponseDetail(
            token,
            props.responseId,
            item.title,
            index,
            item.weight,
          );
      });
      props.refreshResponse();
      props.getResponseLibrary();
    }
    props.closeDrawer(false);
  };
  const addResponseSet = (token, organization, user) => {
    var obj = {
      title: "Custom Response Set",
      company_id: company.id,
      status: "active",
      created_by: user,
      identifier: "Custom",
      custom_identifier: "Local",
      template_id: props.templateId,
    };
    var token = token;
    fetch(GlobalApi + "/Response/create_response", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        var responseId = await res.data.id;
        await responseSet.map(async (item, index) => {
          await addResponseDetail(token, responseId, item.title, index,item.weight);
        });
        props.refreshResponse();
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            addResponseSet(token, organization);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const addResponseDetail = async (token, responseId, title, position,weight) => {
    
    var obj = {
      response_id: responseId,
      title: title,
      weight:weight == '' || weight == undefined ? 0 : weight,
      position: position,
      status: "active",
    };
    
    var token = token;
    await fetch(GlobalApi + "/ResponseDetail/create_response_detail", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    });
    // .then((response) => response.json())
    // .then(async (res) => {
    //   console.log(res.data);
    //   if (res.status === "Success") {
    //   } else if (
    //     res.error === "jwt expired" ||
    //     res.error === "invalid token" ||
    //     res.error === "invalid signature" ||
    //     res.error == "Unexpected token"
    //   ) {
    //     let status = await refresh_token();
    //     console.log(status);
    //     if (status) {
    //       addResponseDetail(token, responseId, title, position);
    //     }
    //   }
    // })
    // .catch((err) => {
    //   console.log(err, "error");
    // });
  };
  const handleTextChange = (event, index,type) => {
    var newresponseSet = [...responseSet];
    if(type=='title')
    newresponseSet[index].title = event.target.value;
    if(type=='weight'){
      if( event.target.value >=0 && event.target.value <=10)
      newresponseSet[index].weight = event.target.value;
      else
      newresponseSet[index].wight = 0
    }
    setResponseSet(newresponseSet);
  };

  const handleDelete = (index) => {
    var newresponseSet = [...responseSet];
    newresponseSet[index].status = "deleted";
    setResponseSet(newresponseSet);
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // styles we need to apply on draggables
    ...draggableStyle,

    ...(isDragging && {
      background: "rgb(235,235,235)",
      height: 80, //50
    }),
  });
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };
  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }
    const reorderItems = await reorder(
      responseSet,
      result.source.index,
      result.destination.index
    );

    console.log(reorderItems)
    await setResponseSet(reorderItems);
  };
  const getResponseLibrary = () => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return false;
      //<Redirect to={'/signin'} />;
    }

    var params = {
      response_id: props.responseId,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(GlobalApi + "/Response/get_response?" + query, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          var list = [];
          var response = res.data;
          var id = response.id;
          var title = response.title;
          var identifier = response.identifier;
         
          var responseList = [];
          await response.ResponseDetails.map((item) => {
            var item = {
              id: item.id,
              title: item.title,
              position: parseInt(item.position),
              status: "added",
              weight:item.weight
            };
            responseList.push(item);
          });

          setResponseSet(responseList.sort((a, b) => a.position - b.position));
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            this.getResponseLibrary();
          }
        }
      })
      .catch((err) => {
        // alert(err);
        console.log(err, "error");
      });
  };
  React.useEffect(() => {
    if (props.action == "edit") {
      getResponseLibrary();
    }
  }, []);
  const updateResponseDetail = async (token, id, title, position, status,weight) => {
    var obj = {
      response_detail_id: id,
      title: title,
      weight:weight=='' || weight== undefined ? 0 : weight,
      position: position,
      status: status === "deleted" ? "frozen" : "active",
    };
    var token = token;
    fetch(GlobalApi + "/ResponseDetail/edit_response_detail", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          props.getResponseLibrary();
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            updateResponseDetail(token, id, title, position,weight);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  console.log(responseSet);
  return (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: props === "top" || props === "bottom",
      })}
      role="presentation"
    >
      {
        <DragDropContext onDragEnd={onDragEnd} className="drag">
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <RootRef rootRef={provided.innerRef}>
                <List>
                  {responseSet
                    .filter((v) => v.status !== "deleted")
                    .map((item, index) => (
                      <Draggable
                        key={item.id}
                        draggableId={item.id}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <Grid
                              container
                              alignItems="center"
                              style={{ padding: 5 }}
                            >
                              <Grid item>
                                <ListItemIcon
                                // style={{ marginTop: 20, alignSelf: "center" }}
                                >
                                  <DragIndicatorRoundedIcon
                                    style={{ color: "gray" }}
                                  />
                                </ListItemIcon>
                              </Grid>
                              <Grid item xs={7} sm={7} md={7}>
                                <TextField
                                  size="small"
                                  fullWidth
                                  onChange={(e) => {
                                    handleTextChange(e, index,"title");
                                  }}
                                  value={item.title}
                                  variant="outlined"
                                />
                              </Grid>
                              <Grid item xs={2} sm={2} md={2}>
                                <TextField
                                  placeholder="Weight"
                                  variant="outlined"
                                  type="number"
                                  size="small"
                                  InputProps={{ inputProps: { min: 0, max: 10 } }}
                                  value={item.weight}
                                  onChange={(e) => {
                                    handleTextChange(e, index,"weight");
                                  }}
                                />
                              </Grid>
                              <Grid item>
                                <IconButton
                                  style={{ marginLeft: 5 }}
                                  onClick={() => handleDelete(index)}
                                >
                                  <DeleteIcon style={{ color: "gray" }} />
                                </IconButton>
                              </Grid>
                            </Grid>
                            <Divider
                              style={{ height: 1, backgroundColor: "#C2C5CC" }}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                </List>
                {provided.placeholder}
              </RootRef>
            )}
          </Droppable>
        </DragDropContext>
      }

      <ListItemIcon
        style={{ marginLeft: 20, cursor: "pointer" }}
        onClick={addResponse}
      >
        {" "}
        <AddIcon /> Add Response
      </ListItemIcon>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Button
          variant={"outlined"}
          style={{
            marginLeft: 10,
            backgroundColor: "#0e76cc",
            color: "#FFFFFF",
          }}
          onClick={closeWithSaveDrawer}
        >
          {" "}
          Save & Close
        </Button>
        <Button
          variant={"outlined"}
          style={{
            marginLeft: 10,
            backgroundColor: "#0e76cc",
            color: "#FFFFFF",
          }}
          onClick={closeDrawer}
        >
          {" "}
          Close
        </Button>
      </div>
    </div>
  );
};
export default function ManageResponse(props) {
  const classes = useStyles();
  const [state, setState] = React.useState(props.responseAction);
  let company = useSelector((state) => state.companyReducer.company);

  React.useEffect(() => {
    if (state != props.responseAction) setState(props.responseAction);
  });

  const closeDrawer = () => {
    props.openResponse(false);
  };

  return (
    <div>
      {
        <SwipeableDrawer
          anchor={"right"}
          open={state}
          //style={{backgroundColor:'#fafafa'}}
          //onClose={toggleDrawer(anchor, false)}
          //onOpen={toggleDrawer(anchor, true)}
        >
          <ResponseList
            closeDrawer={closeDrawer}
            templateId={props.templateId}
            refreshResponse={props.refreshResponse}
            action={props.action}
            responseId={props.responseId}
            getResponseLibrary={props.getResponseLibrary}
          />
        </SwipeableDrawer>
      }
    </div>
  );
}
